import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { resolveImg } from "@/lib/api";
import { TopBar } from "@/components/TopBar";
import { Spinner, EmptyState } from "@/components/common";
import { MessageCircle } from "lucide-react";

export default function Messages() {
  const navigate = useNavigate();
  const [convos, setConvos] = useState(null);
  useEffect(() => { api.get("/conversations").then((r) => setConvos(r.data)).catch(() => setConvos([])); }, []);

  return (
    <div>
      <TopBar greeting="Your chats" name="Messages" />
      <div className="px-4 pt-4">
        {convos === null ? <Spinner /> : convos.length ? (
          <div className="space-y-2">
            {convos.map((c) => (
              <div key={c.conversation_id} data-testid={`convo-${c.conversation_id}`} onClick={() => navigate(`/chat/${c.conversation_id}`)}
                className="flex cursor-pointer items-center gap-3 rounded-3xl bg-white p-3 shadow-soft transition-transform active:scale-[0.99]">
                {c.group ? (
                  <div className="flex h-14 w-14 shrink-0 -space-x-4">
                    {(c.members || []).slice(0, 2).map((m) => <img key={m.user_id} src={resolveImg(m.profile?.photo_url) || "https://images.unsplash.com/photo-1625241152315-4a698f74ceb7?w=200"} alt="" className="h-11 w-11 rounded-2xl border-2 border-white object-cover" />)}
                  </div>
                ) : (
                  <img src={resolveImg(c.other?.profile?.photo_url) || "https://images.unsplash.com/photo-1625241152315-4a698f74ceb7?w=200"} alt="" className="h-14 w-14 rounded-2xl object-cover" />
                )}
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h4 className="line-clamp-1 font-heading font-bold text-ink">{c.group ? c.title : (c.other?.profile?.first_name || c.other?.name)}</h4>
                    {c.group && <span className="rounded-full bg-sun/20 px-2 py-0.5 text-[10px] font-bold text-ink">Tribe</span>}
                  </div>
                  <p className="truncate text-sm text-ink-soft">{c.last_message || "Say hello 👋"}</p>
                </div>
              </div>
            ))}
          </div>
        ) : <EmptyState icon={MessageCircle} title="No conversations yet" sub="Express interest in a room or person to start chatting." />}
      </div>
    </div>
  );
}
